<template>
	<div class="classes">
		<v-container class="py-1 my-1" v-show="show">
			<v-layout row wrap inline-block justify-center>
				<v-flex xs12 sm12 md12>
					<v-card
						flat
						tile
						class="pa-4 Align text-uppercase"
						style="border-top: 1px solid black; border-bottom: 1px solid black;"
					>
						<h2>Upcoming Kids Camps</h2>
					</v-card>
				</v-flex>
				<v-flex
					xs12
					sm8
					md6
					id="about"
					v-for="(evt, index) in eventInfo"
					:key="index"
				>
					<v-card
						flat
						tile
						class="ma-2 border-thing card-overflow"
						max-height="800"
						scrollable
					>
						<v-img class="white--black align-end" height="400" :src="evt.image">
							<v-overlay value="true" absolute>
								<h2 class="text-center pt-2">{{ evt.title }}</h2>
							</v-overlay>
						</v-img>
						<v-card-text>
							<b> Type:</b> Summer Camp <br />
							<b> Age Group:</b> {{ evt.ageGroup }} <br />
							<b> Description:</b> {{ evt.description }} <br />
							<b> Date: </b>{{ evt.date }} - {{ evt.endDate }} <br />
							<b> Time: </b> 8:00am - 4:30pm
						</v-card-text>
						<v-alert type="info">
							Call (303) 447-2400, email info@rockymtanglers.com, or stop in to
							sign up for {{ evt.title }}
						</v-alert>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import fb from "@/fb";

export default {
	data() {
		return {
			eventInfo: [],
			emails: [],
			currentID: "",
			admin: true,
			phoneN: "",
			Email: "",
			Name: "",
			show: false,
			eventsref: fb.db.collection("Events"),
		};
	},
	methods: {
		dateFormatted: function(date) {
			let eventDate = new Date(date);
			var timeOffsetInMS = eventDate.getTimezoneOffset() * 60000;
			eventDate.setTime(eventDate.getTime() + timeOffsetInMS);
			return eventDate.toLocaleDateString("en-US", {
				weekday: "long",
				month: "long",
				day: "numeric",
			});
		},
		timeFormatted: function(time) {
			var timeFormatted;
			var timeCheck = time.slice(0, 2);
			if (timeCheck <= 12) {
				if (timeCheck >= 10) {
					timeFormatted = time.slice(0, 5) + " AM";
				} else {
					timeFormatted = time.slice(1, 5) + " AM";
				}
			} else {
				timeFormatted = timeCheck - 12 + time.slice(2, 5) + " PM";
			}
			return timeFormatted;
		},
		deletePastEvent: function() {},
	},
	async created() {
		this.deletePastEvent("kidsCamp");
		const rawCamps = await this.eventsref
			.where("location.id", "==", "kids-camps")
			.orderBy("timestamp")
			.get();

		for (const camp of rawCamps.docs) {
			this.show = true;
			const campData = camp.data();
			const { date, endDate, time, endTime } = campData;
			this.eventInfo.push({
				...campData,
				show: true,
				date: this.dateFormatted(date),
				endDate: this.dateFormatted(endDate),
				time: this.timeFormatted(time),
				endTime: this.timeFormatted(endTime),
				id: camp.id,
			});
		}
	},
};
</script>
<style scoped>
.card-overflow {
	overflow: scroll;
}

.border-thing {
	border-top: 2px solid grey;
	border-bottom: 3px solid grey;
}
.Align {
	text-align: center;
}
</style>
